import { Component,
         Output,
         EventEmitter,
         ViewChild }                      from '@angular/core';
import { MatDialog,
         MatSnackBar }                    from '@angular/material';
import { OrderLogisticalService }         from './../shared/order-logistical.service';
import { TableColumn,
         TableColumnType }                from './../common/table-column';
import { ISortableFilter,
         SortDirection }                  from './../common/sortable-filter';
import { ProductService }                 from './../shared/product.service';
import { TrainCycleService }              from './../shared/train-cycle.service';
import { TrainService }                   from './../shared/train.service';
import { KitchenService }                 from './../shared/kitchen.service';
import { FormArray,
         FormBuilder,
         FormControl,
         FormGroup }                      from '@angular/forms';
import { Observable }                     from 'rxjs/Observable';
import { toLocalTime,
         toNetParameterDate }             from './../common/functions';
import { OrderSortableFilter, AutoCompleteProductModel }            from './order-sortable-filter';
import { ChartsModule }                   from 'ng2-charts';
import { Chart }                          from 'chart.js';
import { Globals }                        from './../common/globals';
import { map }                            from 'rxjs/operators/map';
import { ProductModel }                   from '../product-dialog/product.model';
import { LoadingDialogComponent }         from '../common/loading-dialog.component';

@Component({
  selector: 'sa-orderlogistical',
  template: require('./order.component.html'),
  styles: [require('./order.component.scss')]
})
export class OrderLogisticalComponent {

  @Output() salesColumns: Array<TableColumn>;

  @Output() orderColumns: Array<TableColumn>;

  @Output() patternColumns: Array<TableColumn>;

  @Output() historyColumns: Array<TableColumn>;

  @Output() salesFilter = new OrderSortableFilter('cycleName', SortDirection.asc);

  @Output() salesRefresh = new EventEmitter();

  @Output() orderRefresh = new EventEmitter();

  @Output() patternRefresh = new EventEmitter();

  @Output() historyRefresh = new EventEmitter();

  @ViewChild('salesListGrid') salesListGrid;

  @ViewChild('orderListGrid') orderListGrid;

  @ViewChild('patternListGrid') patternListGrid;

  products = [];
  dates = [];
  trainCycles = [];
  trainCyclesTrains = [];
  trainCyclesPleaseSelect = [];
  kitchens = [];

  lastSalesData: any;
  lastOrderData: any;
  selectedTrainCycle = new TrainCycle();
  selectedKitchen = '';
  selectedSourceTrainCycle = new TrainCycle();
  selectedDestinationTrainCycle = new TrainCycle();
  sourceAndDestSelected = false;
  initializeNewCycleError = false;

  showsSalesData = false;
  showsOrderData = false;
  showsPatternData = false;
  productsReady = false;
  datesReady = false;
  trainCyclesReady = false;
  kitchensReady = false;
  showsHistoryData = false;
  updatingNewCycle = false;

  public lineChartOrderLabels: Array<any> = ['Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota', 'Neděle'];
  public lineChartOrderOptions: any = {
    responsive: true, maintainAspectRatio: false
  };
  public lineChartOrderColors: Array<any> = [
    {
      backgroundColor: 'rgba(148,159,177,0.7)',
      borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];

  public lineChartSalesData: Array<any> = [
    {data: [0, 0, 0, 0, 0, 0, 0], label: 'Prodáno'},
    {data: [0, 0, 0, 0, 0, 0, 0], label: 'Objednáno'},
    {data: [0, 0, 0, 0, 0, 0, 0], label: 'Odepsáno'}
  ];

  public lineChartOrderData: Array<any> = [
    {data: [0, 0, 0, 0, 0, 0, 0], label: 'Navrženo'}
  ];

  public lineChartSalesLabels: Array<any> = ['Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota', 'Neděle'];
  public lineChartSalesOptions: any = {
    responsive: true, maintainAspectRatio: false
  };
  public lineChartSalesColors: Array<any> = [
    { // blue
      backgroundColor: 'rgba(77,83,143,0.7)',
      borderColor: 'rgba(77,83,143,1)',
      pointBackgroundColor: 'rgba(77,83,143,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,143,1)'
    },
    { // grey
      backgroundColor: 'rgba(148,159,177,0.7)',
      borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    { // red
      backgroundColor: 'rgba(212,159,177,0.7)',
      borderColor: 'rgba(212,159,177,1)',
      pointBackgroundColor: 'rgba(212,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(212,159,177,0.8)'
    }
  ];
  public lineChartSalesLegend = true;
  public lineChartSalesType = 'bar';

  public lineChartOrderLegend = true;
  public lineChartOrderType = 'bar';

  public getSalesDataSyncCallback: Function;
  public getSalesPageDataSyncCallback: Function;

  public getOrderDataSyncCallback: Function;
  public getOrderPageDataSyncCallback: Function;

  public getHistoryDataSyncCallback: Function;
  public getHistoryRowClassCallback: Function;

  private productControl: FormControl;
  private productsAutoComplete: Observable<any>;

  private productControl2: FormControl;

  private trainCycleControl: FormControl;
  private trainCycleAutoComplete: Observable<any>;

  private trainCycleControlAvgSales: FormControl;
  private trainCycleAutoCompleteAvgSales: Observable<any>;

  private trainCycleControlHistory: FormControl;
  private trainCycleAutoCompleteHistory: Observable<any>;

  private trainCycleControlInitSource: FormControl;
  private trainCycleAutoCompleteInitSource: Observable<any>;

  private trainCycleControlInitDest: FormControl;
  private trainCycleAutoCompleteInitDest: Observable<any>;


  constructor(
      private apiService: OrderLogisticalService,
      private productService: ProductService,
      private trainCycleService: TrainCycleService,
      private kitchensService: KitchenService,
      private snackbar: MatSnackBar,
      private trainService: TrainService,
      private dialog: MatDialog,
      public globals: Globals
      ) {
    this.getSalesDataSyncCallback = this.getSalesDataSyncCallbackInner.bind(this);
    this.getOrderDataSyncCallback = this.getOrderDataSyncCallbackInner.bind(this);
    this.getHistoryDataSyncCallback = this.getHistoryDataSyncCallbackInner.bind(this);
    this.getHistoryRowClassCallback = this.getHistoryRowClassCallbackInner.bind(this);

    this.salesColumns = [
      new TableColumn(TableColumnType.Text, 'trainName', 'Spoj', 30),
      new TableColumn(TableColumnType.Text, 'd1', 'Po.', 10, false, null, null, null,
            (val) => {
              return '<b>' + val.sold + '</b>' + '/' + val.ordered + '/' + val.used;
            }),
      new TableColumn(TableColumnType.Text, 'd2', 'Út.', 10, false, null, null, null,
            (val) => {
              return '<b>' + val.sold + '</b>' + '/' + val.ordered + '/' + val.used;
            }),
      new TableColumn(TableColumnType.Text, 'd3', 'St.', 10, false, null, null, null,
            (val) => {
              return '<b>' + val.sold + '</b>' + '/' + val.ordered + '/' + val.used;
            }),
      new TableColumn(TableColumnType.Text, 'd4', 'Čt.', 10, false, null, null, null,
            (val) => {
              return '<b>' + val.sold + '</b>' + '/' + val.ordered + '/' + val.used;
            }),
      new TableColumn(TableColumnType.Text, 'd5', 'Pá.', 10, false, null, null, null,
            (val) => {
              return '<b>' + val.sold + '</b>' + '/' + val.ordered + '/' + val.used;
            }),
      new TableColumn(TableColumnType.Text, 'd6', 'So.', 10, false, null, null, null,
            (val) => {
              return '<b>' + val.sold + '</b>' + '/' + val.ordered + '/' + val.used;
            }),
      new TableColumn(TableColumnType.Text, 'd7', 'Ne.', 10, false, null, null, null,
            (val) => {
              return '<b>' + val.sold + '</b>' + '/' + val.ordered + '/' + val.used;
            })
    ];

    this.orderColumns = [
      new TableColumn(TableColumnType.Text, 'cycleName', 'Spoj', 30),
      new TableColumn(TableColumnType.Text, 'd1', 'Po.', 10, false, null, null, null,
            (val) => {
              return '<b>' + val.proposed + '</b>' + '/' + val.factor;
            }),
      new TableColumn(TableColumnType.Text, 'd2', 'Út.', 10, false, null, null, null,
            (val) => {
              return '<b>' + val.proposed + '</b>' + '/' + val.factor;
            }),
      new TableColumn(TableColumnType.Text, 'd3', 'St.', 10, false, null, null, null,
            (val) => {
              return '<b>' + val.proposed + '</b>' + '/' + val.factor;
            }),
      new TableColumn(TableColumnType.Text, 'd4', 'Čt.', 10, false, null, null, null,
            (val) => {
              return '<b>' + val.proposed + '</b>' + '/' + val.factor;
            }),
      new TableColumn(TableColumnType.Text, 'd5', 'Pá.', 10, false, null, null, null,
            (val) => {
              return '<b>' + val.proposed + '</b>' + '/' + val.factor;
            }),
      new TableColumn(TableColumnType.Text, 'd6', 'So.', 10, false, null, null, null,
            (val) => {
              return '<b>' + val.proposed + '</b>' + '/' + val.factor;
            }),
      new TableColumn(TableColumnType.Text, 'd7', 'Ne.', 10, false, null, null, null,
            (val) => {
              return '<b>' + val.proposed + '</b>' + '/' + val.factor;
            })
    ];

    this.historyColumns = [
      new TableColumn(TableColumnType.Text, 'formatedDate', 'Datum', 15 ),
      new TableColumn(TableColumnType.Text, 'kitchenName', 'kuchyňka', 15),
      new TableColumn(TableColumnType.Text, 'trainName', 'Spoj', 25),
      new TableColumn(TableColumnType.Text, 'type', 'Operace', 15, false, null, null, null,
            (val) => {
                switch (val) {
                    case 'stock':
                    {
                        return 'Sklad při uzávěrce';
                    }
                    case 'sale':
                    {
                        return 'Prodáno';
                    }
                    case 'reception':
                    {
                        return 'Naskladněno';
                    }
                    case 'order':
                    {
                        return 'Objednáno';
                    }
                    case 'return':
                    {
                        return 'Vráceno dodavateli';
                    }
                    case 'usage':
                    {
                        return 'Odepsáno';
                    }
                    case 'st':
                    {
                        return 'Inventura';
                    }
                    case 'stClose':
                    {
                        return 'Inventura uzavírací';
                    }
                    case 'stFull':
                    {
                        return 'Inventura celková';
                    }
                    case 'stPart':
                    {
                        return 'Inventura částečná';
                    }
                    case 'saleInvoice':
                    {
                        return 'Prodáno na fakturu';
                    }
                }
            }),
      new TableColumn(TableColumnType.Number, 'quantity', 'Množství', 10, false, null, null, null,
            (val) => {
              return val;
            })
    ];

    this.patternColumns = this.salesColumns;

    this.salesFilter.product = new AutoCompleteProductModel();

    this.selectedTrainCycle = {'cycleUID': '', 'name': '- Všechny spoje -'};
    this.selectedSourceTrainCycle = {'cycleUID': '', 'name': '- Prosím vyberte -'};
    this.selectedDestinationTrainCycle = {'cycleUID': '', 'name': '- Prosím vyberte -'};

    this.loadProducts();
    this.loadDates();
    this.loadTrainCycles();
    this.loadKitchens();

    this.productControl = new FormControl();
    this.productControl2 = new FormControl();
    this.productsAutoComplete = this.productControl.valueChanges
      .pipe(
        map(prod => prod ? this.filterProductsForSale(prod) : this.products)
      );

    this.trainCycleControl = new FormControl();
    this.trainCycleAutoComplete = this.trainCycleControl.valueChanges
      .pipe(
        map(train => train ? this.filterTrainCycles(train) : this.trainCycles)
      );

    this.trainCycleControlAvgSales = new FormControl();
    this.trainCycleAutoCompleteAvgSales = this.trainCycleControlAvgSales.valueChanges
      .pipe(
        map(train => train ? this.filterTrainCycles(train) : this.trainCycles)
    );

    this.trainCycleControlHistory = new FormControl();
    this.trainCycleAutoCompleteHistory = this.trainCycleControlHistory.valueChanges
      .pipe(
        map(train => train ? this.filterTrainCycles(train) : this.trainCycles)
    );

    this.trainCycleControlInitSource = new FormControl();
    this.trainCycleAutoCompleteInitSource = this.trainCycleControlInitSource.valueChanges
      .pipe(
        map(train => train ? this.filterTrainCycles(train) : this.trainCycles)
    );

    this.trainCycleControlInitDest = new FormControl();
    this.trainCycleAutoCompleteInitDest = this.trainCycleControlInitDest.valueChanges
      .pipe(
        map(train => train ? this.filterTrainCycles(train) : this.trainCycles)
    );
  }

  public getSalesExportFilter(): ISortableFilter {
    let filter = Object.assign({}, this.salesFilter);
    filter.exportFunction = 'SalesExport';
    return filter;
  }

  public getHistoryExportFilter(): ISortableFilter {
    let filter = Object.assign({}, this.salesFilter);
    filter.exportFunction = 'HistoryExport';
    return filter;
  }

  private getSalesDataSyncCallbackInner(filter: ISortableFilter) {
    this.salesFilter.vart = this.salesFilter.product.vart;
    let res = this.apiService.getSalesData(filter);

    res.subscribe(d => {
        this.lastSalesData = d;
        this.updateSalesChartData();
          });

    return res;
  }

  private getOrderDataSyncCallbackInner(filter: ISortableFilter) {
    let res = this.apiService.getOrderData(filter);

    res.subscribe(d => {
        this.lastOrderData = d;
        this.updateOrderChartData();
          });

    return res;
  }

  private getHistoryDataSyncCallbackInner(filter: ISortableFilter) {
    let res = this.apiService.getHistoryData(filter);
    return res;
  }

  private getHistoryRowClassCallbackInner(e: any ): any {
    let style = '';
    switch (e.type) {
        case 'stock':
        {
            style = '';
            break;
        }
        case 'sale':
        case 'saleInvoice':
        {
            style =  'orderHistorySale';
            break;
        }
        case 'reception':
        {
            style =  'orderHistoryReception';
            break;
        }
        case 'order':
        {
            style =  '';
            break;
        }
        case 'return':
        case 'usage':
        {
            style =  'orderHistoryUsage';
            break;
        }
        case 'stClose':
        case 'stFull':
        case 'stPart':
        {
            style =  'orderHistoryInventory';
            break;
        }
        case 'st':
        {
            style =  'orderHistoryInventory';
            break;
        }
    }
    if (e.firstAtDay === true) {
        style = 'orderHistorySalesDiffDate ' + style;
    }
    return style;
  }

  public updateSourceAndDestSelected() {
    this.sourceAndDestSelected = (this.selectedSourceTrainCycle.cycleUID !== '' && this.selectedDestinationTrainCycle.cycleUID !== '');
  }

  public initializeNewCyle() {
    this.updatingNewCycle = true;
    this.apiService.initializeNewCyle( this.selectedSourceTrainCycle.cycleUID, this.selectedDestinationTrainCycle.cycleUID).subscribe(
        (value) => {this.initializeNewCycleError = false;
                    this.initializeNewCycleFinished();
                },
        (error) => {
                    this.initializeNewCycleError = true;
                    this.initializeNewCycleFinished();

                   }
    );
  }

  protected initializeNewCycleFinished() {
    this.updatingNewCycle = false;
    this.selectedSourceTrainCycle.cycleUID = '';
    this.selectedDestinationTrainCycle.cycleUID = '';
  }

  public productFilterChanged(evt, product: any) {
    if (evt.source.selected) {
        this.refreshSalesVart(product);
        if (this.showsHistoryData) {
            this.refreshHistory();
        }
    }
  }

  public trainCyclesFilterChanged(evt, train: any) {
      if (evt.source.selected) {
        this.selectedTrainCycle.cycleUID = train.cycleUID;
        if (this.showsHistoryData) {
            this.refreshHistory();
        }
        this.updateOrderChartData();
        this.refreshSales();
      }
  }

  public trainCycleSourceChanged(evt, train: any) {
      if (evt.source.selected) {
        this.selectedSourceTrainCycle.cycleUID = train.cycleUID;
        this.updateSourceAndDestSelected();
      }
  }

  public trainCycleDestinationChanged(evt, train: any) {
      if (evt.source.selected) {
        this.selectedDestinationTrainCycle.cycleUID = train.cycleUID;
        this.updateSourceAndDestSelected();
      }
  }

  public periodeFilterChanged() {
     this.refreshSales();
     if (this.showsHistoryData) {
        this.refreshHistory();
     }
  }

public refreshSalesVart(prod: any) {
    this.salesFilter.vart = prod.vart;
    this.salesFilter.product = prod;
    this.salesRefresh.emit(this.salesFilter);
}

  public refreshSales() {
      // this.salesFilter.vart = this.salesFilter.product.vart;
      this.salesRefresh.emit(this.salesFilter);
  }

public refreshOrder() {
    this.salesFilter.vart = this.salesFilter.product.vart;
    this.orderRefresh.emit(this.salesFilter);
}

  public refreshOrderVart(evt, vart: string) {
      if (evt.source.selected) {
        this.salesFilter.vart = vart;
        this.orderRefresh.emit(this.salesFilter);
      }
  }

  public refreshHistory() {
      if (typeof this.selectedTrainCycle === 'string') {
        this.salesFilter.cycleUID = this.selectedTrainCycle;
      } else {
        this.salesFilter.cycleUID = this.selectedTrainCycle.cycleUID;
      }
      this.salesFilter.kitchenName = this.selectedKitchen;
      this.historyRefresh.emit(this.salesFilter);
  }

  public tabSelectChange(event) {
    if (event.index === 0) {
        if (!this.showsSalesData) {
            this.showsSalesData = true;
            this.salesListGrid.getPage(1);
        }
        this.refreshSales();
        return;
    }
    if (event.index === 1) {
        if (!this.showsOrderData) {
            this.showsOrderData = true;
            this.orderListGrid.getPage(1);
        }
        this.refreshOrder();
        return;
    }
    if (event.index === 2 && !this.showsPatternData) {
        this.showsPatternData = true;
        return;
    }
  }

  public tabSalesSelectChange(event) {
    this.showsHistoryData = false;
    if (event.index === 2) { // history tab
        this.showsHistoryData = true;
        this.refreshHistory();
        return;
    }
  }

  private loadProducts() {
      let cloakRef = this.dialog.open(LoadingDialogComponent, {disableClose: true});
      if ((this.products === null) || (this.products.length === 0)) {
        this.productService.getSaleableItemsForFilter().subscribe(d => {
        this.products = d;
        this.productsReady = true;
        if (this.products != null && this.products.length > 0) {
            this.salesFilter.vart = this.products[0].vart;
            this.salesFilter.product = this.products[0];
        }
        this.formControlsUpdateValueAndValidity();
        cloakRef.close();
          });
      }
  }

  private formControlsUpdateValueAndValidity() {
        this.productControl.updateValueAndValidity();
        this.productControl2.updateValueAndValidity();
        this.trainCycleControl.updateValueAndValidity();
        this.trainCycleControlAvgSales.updateValueAndValidity();
        this.trainCycleControlHistory.updateValueAndValidity();
        this.trainCycleControlInitSource.updateValueAndValidity();
        this.trainCycleControlInitDest.updateValueAndValidity();
  }

  private loadTrainCycles() {
      if ((this.trainCycles == null) || (this.trainCycles.length === 0)) {
        this.trainCycleService.getItems( new OrderSortableFilter( 'name' ) ).subscribe(d => {
            this.trainCycles.push( {'cycleUID': '', 'name': '- Všechny spoje -'}) ;
            this.trainCyclesTrains.push( {'cycleUID': '', 'name': '- Všechny spoje -'}) ;
            this.trainCyclesPleaseSelect.push( {'cycleUID': '', 'name': '- Prosím vyberte -'}) ;
            this.trainCycles = this.trainCycles.concat( d );
            this.trainCyclesTrains = this.trainCyclesTrains.concat( d );
            if (this.trainCycles != null && this.trainCycles.length > 0) {
                this.selectedTrainCycle.cycleUID = this.trainCycles[0].cycleUID;
            }
            // append trains to the traincyclestrains array
            this.trainService.getItems( new OrderSortableFilter( 'descr' ) ).subscribe((tr) => {
                tr.forEach(element => {
                    this.trainCyclesTrains.push( {name : element.descr, cycleUID: element.trainUid } );
                });
                this.trainCyclesTrains.sort(function(a, b) {
                    // tslint:disable-next-line:curly
                    if (a.name < b.name) return -1;
                    // tslint:disable-next-line:curly
                    if (a.name > b.name) return 1;
                    return 0;
                })
                this.trainCyclesReady = true;
            });
        });
      }
  }

  private loadKitchens() {
      if ((this.kitchens == null) || (this.kitchens.length === 0)) {
        this.kitchensService.getItems( new OrderSortableFilter( 'name' ) ).subscribe(d => {
            this.kitchens.push( {'kitchenID': '', 'name': '- Všechny kuchyňky -'}) ;
            for (let k of d) {
                this.kitchens.push({'kitchenID': k.name, 'name': k.name});
            }
            this.kitchensReady = true;
            if (this.kitchens != null && this.kitchens.length > 0) {
                this.selectedKitchen = this.kitchens[0].kitchenID;
            }
          });
      }
  }

  private loadDates() {
      let year = new Date().getFullYear();
      this.dates.push( {'id': '', 'year': year, 'month': new Date().getMonth(), 'description': 'Poslední 4 týdny' } )
      this.dates = this.dates.concat( this.loadDatesForYear( year - 1));
      this.dates = this.dates.concat( this.loadDatesForYear( year ));
      this.salesFilter.dateId = ''; // new Date().getFullYear() + "_" + (new Date().getMonth() + 1);
      this.datesReady = true;
  }

  private loadDatesForYear( y ): object[] {
    let months: {nr: number, m: string}[] = [
        {'nr': 1, 'm': 'Leden'},
        {'nr': 2, 'm': 'Únor'},
        {'nr': 3, 'm': 'Březen'},
        {'nr': 4, 'm': 'Duben'},
        {'nr': 5, 'm': 'Květen'},
        {'nr': 6, 'm': 'Červen'},
        {'nr': 7, 'm': 'Červenec'},
        {'nr': 8, 'm': 'Srpen'},
        {'nr': 9, 'm': 'Září'},
        {'nr': 10, 'm': 'Říjen'},
        {'nr': 11, 'm': 'Listopad'},
        {'nr': 12, 'm': 'Prosinec'}
    ]

    let list: {id: string, year: number, month: number, description: string}[] = []

    for (let mm of months) {
        list.push( {'id': y + '_' + mm.nr, 'year': y, 'month': mm.nr, 'description': y + '-' + mm.m});
    }
    return list;
  }

  // ------------------------------------------------------------------------------------------------------------------------
  // Line chart sales functions

  public clearSalesChartData() {
    this.lineChartSalesData = [
        {data: [0, 0, 0, 0, 0, 0, 0], label: 'Prodáno'},
        {data: [0, 0, 0, 0, 0, 0, 0], label: 'Objednáno'},
        {data: [0, 0, 0, 0, 0, 0, 0], label: 'Odepsáno'}
    ];
  }

  public updateSalesChartData() {
    this.clearSalesChartData();
    if (this.lastSalesData == null) {
        return;
    }
    for (let sd of this.lastSalesData) {   // selected is train or cycle, UID is unique so both will work
        if ((this.selectedTrainCycle.cycleUID == null) || (this.selectedTrainCycle.cycleUID === '')  ||
            (this.selectedTrainCycle.cycleUID === sd.cycleUID)  || (this.selectedTrainCycle.cycleUID === sd.trainUID)) {

            this.lineChartSalesData[0].data[0] += sd.d1.sold;
            this.lineChartSalesData[1].data[0] += sd.d1.ordered;
            this.lineChartSalesData[2].data[0] += sd.d1.used;

            this.lineChartSalesData[0].data[1] += sd.d2.sold;
            this.lineChartSalesData[1].data[1] += sd.d2.ordered;
            this.lineChartSalesData[2].data[1] += sd.d2.used;

            this.lineChartSalesData[0].data[2] += sd.d3.sold;
            this.lineChartSalesData[1].data[2] += sd.d3.ordered;
            this.lineChartSalesData[2].data[2] += sd.d3.used;

            this.lineChartSalesData[0].data[3] += sd.d4.sold;
            this.lineChartSalesData[1].data[3] += sd.d4.ordered;
            this.lineChartSalesData[2].data[3] += sd.d4.used;

            this.lineChartSalesData[0].data[4] += sd.d5.sold;
            this.lineChartSalesData[1].data[4] += sd.d5.ordered;
            this.lineChartSalesData[2].data[4] += sd.d5.used;

            this.lineChartSalesData[0].data[5] += sd.d6.sold;
            this.lineChartSalesData[1].data[5] += sd.d6.ordered;
            this.lineChartSalesData[2].data[5] += sd.d6.used;

            this.lineChartSalesData[0].data[6] += sd.d7.sold;
            this.lineChartSalesData[1].data[6] += sd.d7.ordered;
            this.lineChartSalesData[2].data[6] += sd.d7.used;
        }
    }

  }

  // events
  public chartSalesClicked(e: any): void {
  }

  public chartSalesHovered(e: any): void {
  }

  // ------------------------------------------------------------------------------------------------------------------------
  // Line chart order functions



  public clearOrderChartData() {
    this.lineChartOrderData = [
        {data: [0, 0, 0, 0, 0, 0, 0], label: 'Navrženo'},
    ];
  }

  public updateOrderChartData() {
    this.clearOrderChartData();
    if (this.lastOrderData == null) {
        return;
    }
    for (let sd of this.lastOrderData) {
        if ((this.selectedTrainCycle.cycleUID == null) ||
            (this.selectedTrainCycle.cycleUID === '')  ||
            (this.selectedTrainCycle.cycleUID === sd.cycleUID)) {
            this.lineChartOrderData[0].data[0] += sd.d1.proposed;

            this.lineChartOrderData[0].data[1] += sd.d2.proposed;

            this.lineChartOrderData[0].data[2] += sd.d3.proposed;

            this.lineChartOrderData[0].data[3] += sd.d4.proposed;

            this.lineChartOrderData[0].data[4] += sd.d5.proposed;

            this.lineChartOrderData[0].data[5] += sd.d6.proposed;

            this.lineChartOrderData[0].data[6] += sd.d7.proposed;
        }
    }

  }

  filterProductsForSale(input) {

    if (typeof input !== 'string') {
      return this.products;
    }

    return this.products.filter(product =>
        product.description.toLowerCase().indexOf(input.toLowerCase()) > -1);
  }

  filterTrainCycles(input) {
    if (typeof input !== 'string') {
      return this.trainCycles;
    }

    return this.trainCycles.filter(train =>
        train.name.toLowerCase().indexOf(input.toLowerCase()) > -1);
  }

  private autoProductsDisplayFn(product: any) {
    if (!product) { return ''; }
    return product.description;
  }

  private autoTrainCyclesDisplayFn(train: any) {
      if (!train) { return ''; }
      return train.name;
  }

  // events
  public chartClicked(e: any): void {
  }

  public chartHovered(e: any): void {
  }
}

export class TrainCycle {
    cycleUID: string;
    name: string;

    constructor() {
        this.cycleUID = '';
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/order-logistical/order.component.ts